import React from "react";
import { useContent } from "../../content/ContentContext";

export const MissionVision = () => {
  const c = useContent("mission_vision");
  return (
    <section data-testid="mission-vision-section" className="sc-blush-bg">
      <div className="sc-container py-20 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20">
          <div data-testid="mission-block">
            <span className="sc-eyebrow">{c.mission_eyebrow}</span>
            <p className="font-serif text-2xl md:text-[1.75rem] leading-[1.35] text-ink mt-4 max-w-md">
              {c.mission_pre}{" "}
              <em className="not-italic text-magenta">{c.mission_em}</em>
            </p>
          </div>
          <div data-testid="vision-block">
            <span className="sc-eyebrow">{c.vision_eyebrow}</span>
            <p className="font-serif text-2xl md:text-[1.75rem] leading-[1.35] text-ink mt-4 max-w-md">
              {c.vision_pre}{" "}
              <em className="not-italic">{c.vision_em}</em>{" "}
              {c.vision_post}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;
